import React, { useState } from 'react'
import paymentinfoStyle from './paymentInfo.module.css'
import { useCart } from '../../../context/CartContext';
require('typeface-poppins')

export default function PaymentInfo() {

    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const { cart, clearCart } = useCart();

    const [cardNumber, setCardNumber] = useState('');
    const [expiry, setExpiry] = useState('');
    const [cvv, setCvv] = useState('');
    const [zipCode, setZipCode] = useState('');

    return (
        <>
            <div className={paymentinfoStyle.paymentinfoWrapper}>
                <div className="mb-3">
                    <input type="text" className={`${paymentinfoStyle.paymentinfoInput} form-control`}
                        placeholder='*Credit Card Number' value={cardNumber} onChange={(e) => setCardNumber(e.target.value)} />
                </div>
                <div className="mb-3">
                    <input type="text" className={`${paymentinfoStyle.paymentinfoInput} form-control`}
                        placeholder='*MM/YY' value={expiry} onChange={(e) => setExpiry(e.target.value)} />
                </div>
                <div className="mb-3">
                    <input type="text" className={`${paymentinfoStyle.paymentinfoInput} form-control`}
                        placeholder='*CVV' value={cvv} onChange={(e) => setCvv(e.target.value)} />
                </div>
                <div className="mb-3">
                    <input type="text" className={`${paymentinfoStyle.paymentinfoInput} form-control`} placeholder='*Zip Code'
                        value={zipCode} onChange={(e) => setZipCode(e.target.value)} />
                </div>
            </div>
        </>
    )
}
